module.exports = __webpack_public_path__ + "img/nosearchdataCT.2f48944e.svg";